import { Component, Input } from '@angular/core';

/**
 * Presentational component — top-level error banner with outlined-circle ⓘ icon + message text.
 * Renders nothing when `message` is empty/falsy.
 *
 * Usage:
 *   <app-healthpicks-error-banner [message]="errorMessages.login.password"></app-healthpicks-error-banner>
 *
 * The host element itself carries role="alert" so screen readers announce it automatically.
 */
@Component({
  selector: 'app-healthpicks-error-banner',
  template: `
    <div class="hp-error-banner" *ngIf="message" role="alert">
      <span class="hp-error-banner__icon" aria-hidden="true">
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
          <circle cx="10" cy="10" r="9" stroke="#BE4751" stroke-width="1.5"/>
          <rect x="9.25" y="8.5" width="1.5" height="5.5" rx="0.75" fill="#BE4751"/>
          <rect x="9.25" y="6"   width="1.5" height="1.5" rx="0.75" fill="#BE4751"/>
        </svg>
      </span>
      <span class="hp-error-banner__text">{{ message }}</span>
    </div>
  `,
  styles: [`
    .hp-error-banner {
      display: flex;
      align-items: center;
      gap: 4px;
      background: #fadddf;
      outline: 1px solid #be4751;
      border-radius: 12px;
      padding: 16px;
      overflow: hidden;
    }

    .hp-error-banner__icon {
      flex-shrink: 0;
      display: flex;
      align-items: flex-start;
      width: 20px;
      height: 20px;
    }

    .hp-error-banner__icon svg {
      width: 20px;
      height: 20px;
    }

    .hp-error-banner__text {
      font-family: var(--hp-font) !important;
      font-size: 12px;
      font-weight: 400;
      color: #be4751;
      line-height: 1.5;
      letter-spacing: 0.36px;
      font-feature-settings: 'halt';
      white-space: nowrap;
    }

    /* Layout-transparent when empty so hp-input-area gap only appears when banner is visible */
    :host {
      display: contents;
    }
  `],
})
export class HealthpicksErrorBannerComponent {
  /** Error message to display. Component is hidden when falsy. */
  @Input() message = '';
}
